export const HERO_IMG =
    "https://static.prod-images.emergentagent.com/jobs/5e849b05-46bf-4c6c-9e1a-29320f42f4e6/images/4a999c4f696e6cc65db7bcbc82e14e70277b23ea8ef935973ac594012d7368f8.jpeg";

export const LOCATION_LEVELS = [
    { n: "L.01", label: "LOCAL SUPPLIER", tag: "PRIORITY" },
    { n: "L.02", label: "CITY / METRO" },
    { n: "L.03", label: "PROVINCE" },
    { n: "L.04", label: "REGIONAL REFERENCE" },
    { n: "L.05", label: "NATIONAL REFERENCE" },
];

export const TRANSPARENCY_FIELDS = [
    {
        n: "T.01",
        title: "EXACT PRODUCT",
        copy: "The precise item and pack size, so you know what was actually priced.",
    },
    {
        n: "T.02",
        title: "SPECIFICATION",
        copy: "The technical detail behind the product, so comparisons are like-for-like.",
    },
    {
        n: "T.03",
        title: "SUPPLIER",
        copy: "Where the price came from, so the source is never anonymous.",
    },
    {
        n: "T.04",
        title: "LOCATION",
        copy: "Pricing that reflects where you are building, not a national average.",
    },
    {
        n: "T.05",
        title: "PRICE",
        copy: "The verified figure itself, shown exactly as recorded.",
    },
    {
        n: "T.06",
        title: "DATE VERIFIED",
        copy: "When it was checked, so information never goes stale silently.",
    },
];

export const PRICE_CARD = {
    product: "50kg Cement",
    supplier: "Example Building Supplies",
    location: "Durban, KwaZulu-Natal",
    price: "R123.95",
    status: "VERIFIED TODAY",
    vat: "Excluded",
    delivery: "Excluded",
};
